import { render, staticRenderFns } from "./VehicleProvisionBrigadesQueue.vue?vue&type=template&id=35f6e90a&scoped=true&"
import script from "./VehicleProvisionBrigadesQueue.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionBrigadesQueue.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionBrigadesQueue.vue?vue&type=style&index=0&id=35f6e90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6e90a",
  null
  
)

export default component.exports
import {QField,QTable,QTh,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QField,QTable,QTh,QTr,QTd}, component.options.components || {})
